<script setup>
import { useI18n } from 'vue-i18n';
import WhatsappBroadcastCard from './WhatsappBroadcastCard.vue';

defineProps({
  campaigns: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['edit', 'delete', 'toggle', 'report']);

const { t } = useI18n();
</script>

<template>
  <div class="grid gap-4">
    <WhatsappBroadcastCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :campaign="campaign"
      @edit="emit('edit', campaign)"
      @delete="emit('delete', campaign)"
      @toggle="emit('toggle', campaign)"
      @report="emit('report', campaign)"
    />
  </div>
</template>
